import { render, staticRenderFns } from "./ChooseGoodsNav.vue?vue&type=template&id=01d52c6a&"
import script from "./ChooseGoodsNav.vue?vue&type=script&lang=js&"
export * from "./ChooseGoodsNav.vue?vue&type=script&lang=js&"
import style0 from "./ChooseGoodsNav.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ChooseGoodsNav.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports